<template>
  <header class="workspace-header">
    <div class="logo">
      <suite-logo :logo="userSettings.companySettings.logo" class="logo" size="lg" />
    </div>
    <div class="workspace-header-text">
      <h1 class="welcome-text title">
        {{ t(`home.${welcomeMessage}`) }} <span class="user-highlight title">{{ props.name }}</span>
      </h1>
      <p class="welcome-sub-text">{{ t('home.subTitle') }}</p>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {useLocale} from "@/composables/useLocale.ts";
import {useSettingsStore} from "@/stores/useSettingsStore.ts";
import SuiteLogo from "@/components/SuiteLogo.vue";

const { t } = useLocale();
const { userSettings } = useSettingsStore()

const props = withDefaults(
    defineProps<{
      name: string;
    }>(),
    {
      name: 'User'
    }
);

const welcomeMessage = computed(() => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    return 'greeting.morning';
  }
  else if (hour >= 12 && hour < 16) {
    return 'greeting.afternoon';
  }
  else {
    return 'greeting.evening';
  }
});
</script>

<style scoped>
.workspace-header {
  margin-block: 20px 44px;
  display: flex;
  gap: 12px;
}

.workspace-header-text {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.welcome-text {
  color: #363131;
  font-size: 1.2rem;
  margin: 0;
}

.user-highlight {
  color: var(--ion-color-primary);
  /* background: var(--secondary-color); */
  background: var(--grediant-color);
  font-weight: 900;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.welcome-sub-text {
  color: var(--font-700);
  font-size: .9rem;
  margin: 0;
  font-weight: 400;
}

.logo {
  height: 65px;
  width: 65px;
}

@media (min-width: 768px) {
  .welcome-text {
    font-size: 2.5rem;
  }
  .welcome-sub-text {
    font-size: 1.15rem;
  }
  .logo {
    height: 85px;
    width: 85px;
  }
  .workspace-header {
    margin-block: 44px;
  }
}

</style>